import { gql } from '@zenbusiness/application-commons-graphql';

export const CONTACT_FIELDS = gql`
  fragment contactFields on ContactLegacy {
    contactUuid
    companyName
    firstName
    middleName
    lastName
    suffix
    address1
    address2
    city
    state
    zip
    phone
    email
  }
`;
